import ReactDOM from "react-dom";
import "./index.css";
import "./style/custom.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import ReferralTracker from "./services/ReferralTracker";

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <ReferralTracker />
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
